export const useSocPublicImageBucketUrl = (fileNameWithExtension: string) => {
  return `https://soc-website-public.s3.amazonaws.com/static/soc-website/images/manual/${fileNameWithExtension}`
}
